import { MESSAGE_TYPES } from '../types/messages';
import type { ChatMessage, MessageType } from '../types/messages';

export const AI_MODE_LABELS = {
  SEARCH_TRIP: 'AI予約モード',
  SEARCH_SUPPORT: '情報検索モード'
} as const;

// TODO: メッセージ配列が時系列で並んでいること（末尾ほど新しい）を前提に末尾から走査している。並びを保証できない呼び出しが増えたら createdAt 等で明示的に最新を選ぶ
const getLatestEffectiveAiMessage = (
  messages: (Pick<ChatMessage, 'direction' | 'type'> & Record<string, unknown>)[]
): (Pick<ChatMessage, 'direction' | 'type'> & Record<string, unknown>) | null => {
  const ignorableTypes: readonly MessageType[] = [
    MESSAGE_TYPES.OPTIMISTIC,
    MESSAGE_TYPES.ERROR,
    MESSAGE_TYPES.SYSTEM
  ];
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message.direction !== 'ai') continue;
    if (message.type != null && ignorableTypes.includes(message.type)) continue;
    return message;
  }
  return null;
};

export const getCurrentAiModeLabel = (
  messages: (Pick<ChatMessage, 'direction' | 'type'> & Record<string, unknown>)[]
): string => {
  const latestEffectiveAiMessage = getLatestEffectiveAiMessage(messages);
  if (latestEffectiveAiMessage == null) return AI_MODE_LABELS.SEARCH_TRIP;
  if (latestEffectiveAiMessage.type === MESSAGE_TYPES.SEARCH_SUPPORT_INSIGHT) return AI_MODE_LABELS.SEARCH_SUPPORT;
  return AI_MODE_LABELS.SEARCH_TRIP;
};
